import { EfsMelcoModelsDesign } from "melco-shared-logic";
import { useTranslation } from "react-i18next";
import { DesignTokens, InfoIcon, Popover } from "melco-ui";
import styled from "styled-components";
import { DesignInfos } from "./DesignInfos";
import { CanvasActionGroup } from "../../canvas/CanvasActionGroup";
import { DesignCanvasWorkingArea } from "./DesignCanvasWorkingArea";
import { CanvasActionGroupItem } from "../../canvas/CanvasActionGroupItem";
import { RenderedDesign } from "../../renderer/RenderedDesign";
import { isPrintDesignFileName } from "../../../helper/designHelper";
import { PreviewedDesign } from "../../renderer/PreviewedDesign";

const { spacings } = DesignTokens;

const DesignWrapper = styled.div`
  display: flex;
  margin: 0 -${spacings.xlarge}px;
`;

type DesignCanvasProps = {
  design: EfsMelcoModelsDesign;
  showStaticImage?: boolean;
};

export const DesignCanvas: React.FC<DesignCanvasProps> = ({
  design,
  showStaticImage,
}) => {
  const { t } = useTranslation();

  const { file_name } = design;

  const isPrintFile = isPrintDesignFileName(file_name!);

  return (
    <DesignWrapper>
      <DesignCanvasWorkingArea
        actionGroups={
          <CanvasActionGroup positionY="top" positionX="right">
            <Popover
              content={<DesignInfos design={design} />}
              title={t("libraries.designs.detail.form.design_infos.title")}
              trigger="click"
              placement="topRight"
            >
              <CanvasActionGroupItem>
                <InfoIcon data-cy-id="design-infos" />
              </CanvasActionGroupItem>
            </Popover>
          </CanvasActionGroup>
        }
      >
        {isPrintFile || showStaticImage ? (
          <PreviewedDesign design={design} />
        ) : (
          <RenderedDesign design={design} />
        )}
      </DesignCanvasWorkingArea>
    </DesignWrapper>
  );
};
